var exports = {
  "Kk": "GuildMemberActionsSheet.module__icon___UXBlUE",
  "wx": "GuildMemberActionsSheet.module__header___UXBlUE",
  "Se": "GuildMemberActionsSheet.module__headerInfo___UXBlUE",
  "Bv": "GuildMemberActionsSheet.module__headerName___UXBlUE",
  "sD": "GuildMemberActionsSheet.module__headerTag___UXBlUE",
  "im": "GuildMemberActionsSheet.module__headerAvatarImg___UXBlUE",
};

module.exports = exports;
